import userManager from "@/plumbing/auth";
import router from "@/router";
import axios, { AxiosResponse } from "axios";

export const executeApiRequest = async <T>(action: () => Promise<AxiosResponse<T>>, redirectOnError = true) => {
  try {
    const response = await action();

    if (response.status >= 400) {
      if (redirectOnError && router.currentRoute.name !== "Error") {
        router.push({ name: "Error" });
      }
    }

    return response;
  } catch (error) {
    console.error(error);
    if (error?.response?.status === 401) {
      userManager.signinRedirect();
      throw error;
    }
    if (redirectOnError && router.currentRoute.name !== "Error") {
      router.push({ name: "Error" });
    } else {
      throw error;
    }
  }
  return Promise.reject();
};

export const executeApiRequestWithCancellation = async <T>(action: () => Promise<AxiosResponse<T>>, redirectOnError = true) => {
  try {
    const response = await action();

    if (response.status >= 400) {
      if (redirectOnError && router.currentRoute.name !== "Error") {
        router.push({ name: "Error" });
      }
    }

    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.debug("Request cancelled", error.message);
      return null;
    } else {
      console.error(error);
      if (error?.response?.status === 401) {
        userManager.signinRedirect();
        throw error;
      }
      if (redirectOnError && router.currentRoute.name !== "Error") {
        router.push({ name: "Error" });
      } else {
        throw error;
      }
    }
  }
  return Promise.reject();
};
